var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"spinner-border spinner-border-md text-primary",attrs:{"role":"status","aria-hidden":"true"}}),_c('span',{class:_vm.textSize},[_vm._v("Loading please wait...")])])}
var staticRenderFns = []

export { render, staticRenderFns }